module.exports = fox._r("images/promo-image-1.jpg", __webpack_public_path__ + "images/promo-image-1.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/promo-image-1.jpg
// module id = 970
// module chunks = 4